import React from "react";
import "./Loading.css";

const Loading = () => {
  return (
    <div className="loading_wrapper">
      <div className="loading"></div>
    </div>
  );
};

export default Loading;
